import React from 'react';

interface TagListProps {
  modifiers?: string;
  className?: string;
  children?: React.ReactNode;
}

const TagList = ({ modifiers, className, children }: TagListProps) => {
  return (
    <div data-am-tag={modifiers} className={className}>
      <div className="tag-container">{children}</div>
    </div>
  );
};

export default TagList;
